import { useLocation } from "react-router-dom"
import Selection, { SelectionItem, SubNavItem } from "@hydrologiq/shared/selection/Selection"
import { pages } from "./pages"
import { routing } from "./routing"
import { useRoute } from "@hydrologiq/shared/providers/helpers/useRoute"

function AlertsSelection({ children }: { children?: React.ReactNode }) {
  const route = useRoute()
  const location = useLocation().pathname

  // Create parents for breadcrumb navigation
  const sectionPages = pages(location)
  // Create sub-navigation items from sectionPages
  const subNavItems: SubNavItem[] = Object.entries(sectionPages.pages).map(([key, value]) => ({
    name: value,
    href: routing(route, location, false, key),
    disabled: false,
  }))

  // Create parents for breadcrumb navigation
  const parents: SelectionItem[] = []
  const itemFromSubNav = subNavItems.find((subNavItem) => subNavItem.href === location)


  return (
    <Selection
      sectionBase="alerts"
      sectionHeading="Alerts"
      item={itemFromSubNav ? { id: itemFromSubNav.name, name: itemFromSubNav.name } : undefined}
      parents={parents}
      subNavItems={subNavItems}
      subNavHome={sectionPages.defaultPage}
    >
      {children}
    </Selection>
  )
}

export default AlertsSelection
